import { ColumnHeightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";

import { MfErrorsListStore } from "../MfErrorsListStore";
import * as styles from "./MfErrorsListCollapsed.module.less";

type PropsMfErrorsListCollapsed = {
  store: MfErrorsListStore;
};

export const MfErrorsListCollapsed: React.FC<PropsMfErrorsListCollapsed> =
  observer(({ store }) => {
    const { color } = store;
    return (
      <div className={classNames([styles.collapsedBox, styles[color]])}>
        <div className={styles.title}>Ошибки и предупреждения</div>
        <Button
          size="small"
          icon={<ColumnHeightOutlined />}
          onClick={() => store.expand()}
        />
      </div>
    );
  });
